import { 
  FaFacebookF, 
  FaTwitter, 
  FaInstagram, 
  FaYoutube 
} from "react-icons/fa";
import { SITE_TITLE, SITE_DESCRIPTION, CONTACT_INFO } from "@/lib/constants";

export default function Footer() {
  return (
    <footer className="bg-[#4A1D6E] text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="font-['Playfair_Display'] text-xl mb-4">{SITE_TITLE}</h3>
            <p className="mb-2">{SITE_DESCRIPTION}</p>
            <p className="text-[#D4AF37]">Founded 2009</p>
          </div>
          
          <div>
            <h3 className="font-['Playfair_Display'] text-xl mb-4">Contact</h3>
            <p className="mb-2">Email: {CONTACT_INFO.email}</p>
            <p className="mb-2">Phone: {CONTACT_INFO.phone.join(' / ')}</p>
            <p>Rehearsals: {CONTACT_INFO.rehearsals.day} {CONTACT_INFO.rehearsals.time}, {CONTACT_INFO.rehearsals.location.split(',')[0]}</p>
          </div>
          
          <div>
            <h3 className="font-['Playfair_Display'] text-xl mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <a href="#" className="text-white hover:text-[#D4AF37] transition duration-300" aria-label="Facebook">
                <FaFacebookF className="text-2xl" />
              </a>
              <a href="#" className="text-white hover:text-[#D4AF37] transition duration-300" aria-label="Twitter">
                <FaTwitter className="text-2xl" />
              </a>
              <a href="#" className="text-white hover:text-[#D4AF37] transition duration-300" aria-label="Instagram">
                <FaInstagram className="text-2xl" />
              </a>
              <a href="#" className="text-white hover:text-[#D4AF37] transition duration-300" aria-label="YouTube">
                <FaYoutube className="text-2xl" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p>&copy; {new Date().getFullYear()} Clyde Wind Ensemble. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
